<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>Vat</strong>
          </CCardHeader>
          <CCardBody ref="add_container">
            <CRow>
              <CCol col="4">
                <CInput
                    label="Vat"
                    v-model="name"
                    autocomplete="name"

                />
              </CCol>


            </CRow>

          </CCardBody>
          <CCardFooter>
            <CButton v-if="status_form ==0" @click="insert_data()"
                     type="submit" size="sm" color="primary">
              <CIcon name="cil-check-circle"/>
              {{ $t('buttons.edit') }}
            </CButton>
<!--            <CButton v-if="status_form !=0" @click="insert_data()"-->
<!--                     type="submit" size="sm" color="primary">-->
<!--              <CIcon name="cil-check-circle"/>-->
<!--              {{ $t('buttons.editCategory') }}-->
<!--            </CButton>-->
<!--            <CButton @click="emptyList()" type="reset" size="sm" color="danger">-->
<!--              <CIcon name="cil-ban"/>-->
<!--              {{ $t('buttons.emptyForm') }}-->
<!--            </CButton>-->
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];


export default {
  name: 'Login',
  data() {
    return {
      name: '',

      status_form: 0
    }
  }, mounted() {

  }, watch: {

  },
  methods: {

  }
}

</script>
